// ** React Imports
import { Button } from "semantic-ui-react";
import PlanCard from "../../components/layout/PlanCard";
import { useDispatch } from "react-redux";
import { selectPlan } from "../../store/actions/newSignup";
const Step4 = (props) => {
  const dispatch = useDispatch();
  const handleNext = (plan) => {
    dispatch(selectPlan(plan.planId, props.userUid));

    props.stepper.next();
    window.scroll(0, 0);
  };
  return (
    <>
      <div className="step-header">
        <h2 className="step-header-head">Payment Plan</h2>
      </div>
      <div
        className={`new-student-package ${
          props.plans.length <= 1 ? "onlyOne" : ""
        }`}
      >
        {props.plans.map((plan) => (
          <PlanCard
            nextHandler={(p) => handleNext(p)}
            onSignUp={true}
            plan={plan}
          />
        ))}
      </div>
      <div className="footer-btn-data single">
        <Button
          onClick={() => {
            props.stepper.previous();
            window.scroll(0, 0);
          }}
        >
          Back
        </Button>
      </div>
    </>
  );
};
export default Step4;
